import { MenuEntryType } from "@hermes/api-model-shell";
import { MenuEntryItem } from "@hermes/states/menu";
const minHeight = "42px";

// This function return the category max height for each menu entry to avoid to have too many empty blank in the menu.
// You can see the differents rules here : https://jira.tools.hermes.com/browse/APLBLG-185277
// To calc this max height we need some css specs :
// - The height of LVL 2 (spanHeight)
// - The height of LVL 3 (liHeight)
// - The gap between each LVL 2 (rowGap)
// - The margin betweekn each LVL 3 (liMargin)
// /!\ DON'T FORGET TO MODIFY THE DIFFERENTS CSS FILES LINK TO THESES SPECS IF YOU EDIT THEM /!\
export const getCategoryMaxHeight = (menuEntry: MenuEntryItem): string => {
    // LVL 2
    const lvl2Weighting: number = 1;
    const spanHeight: number = 14;

    // Space between each LVL 2
    const rowGap: number = 24;

    // LVL 3
    const lvl3Weighting: number = 0.75;
    const liMargin: number = 8;
    const liHeight: number = 20 + liMargin;

    const subMenuTotal: number = menuEntry.menuEntryList.length;
    let subSubMenuLengthMax: number = 0;
    let subSubMenuTotal: number = 0;

    for (const subMenu of menuEntry.menuEntryList) {
        if (subMenu.type !== MenuEntryType.separatorMenuEntry) {
            subSubMenuTotal += subMenu.menuEntryList.length;
            subSubMenuLengthMax = Math.max(
                subSubMenuLengthMax,
                subMenu.menuEntryList.length,
            );
        }
    }

    const minMaxHeight = calcMinMaxHeight(spanHeight, rowGap);

    const totalWeighting = calcTotalWeighting(
        subMenuTotal,
        lvl2Weighting,
        subSubMenuTotal,
        lvl3Weighting,
    );

    let maxHeight = spanHeight + liHeight * subSubMenuLengthMax;

    if (maxHeight < 128 && totalWeighting > 10) {
        maxHeight = minMaxHeight;
    }

    return `${maxHeight}px`;
};

// This fonction is used to calc the minimum of max height to avoid to have several LVL 2 on one single row.
export const calcMinMaxHeight = (spanHeight: number, rowGap: number): number =>
    spanHeight * 5 + rowGap * 4;

// This fonction is used to calc the total of subMenu weighting to check if we need to apply the default minMaxHeight.
export const calcTotalWeighting = (
    subMenuTotal: number,
    lvl2Weighting: number,
    subSubMenuTotal: number,
    lvl3Weighting: number,
): number => subMenuTotal * lvl2Weighting + subSubMenuTotal * lvl3Weighting;

export const getCategoryMinHeight = (menuEntry: MenuEntryItem): string => {
    let subMenuLength: number = 0;

    let hasItemInSubMenu: boolean = false;
    for (const subMenu of menuEntry.menuEntryList) {
        if (
            subMenu.type !== MenuEntryType.separatorMenuEntry &&
            subMenu.menuEntryList.length > 0
        ) {
            hasItemInSubMenu = true;
        }
    }

    if (hasItemInSubMenu) {
        // to avoid conflict with getCategoryMaxHeight
        return minHeight;
    }

    subMenuLength = Math.max(subMenuLength, menuEntry.menuEntryList.length);

    if (subMenuLength > 4) {
        // minHeightMax for categories with no subSubMenu, equivalent to 4 lvl2
        return "128px";
    }

    const liMargin: number = 24;
    const liHeight: number = 14;

    return `${liMargin * (subMenuLength - 1) + liHeight * subMenuLength}px`;
};
